import React, { useEffect, useState } from 'react';
import _ from "lodash";
import Piechart from "components/charts/PieChart";
import { HorizontalBarchart } from "components/charts/HorizontalBarchart";
import { useTestObjectRef, BI } from 'utils/testUtils';
import { useDispatch, useSelector, useStore } from "react-redux";
import { readcheckedfilterAllCompanyResultsByLawyerIds } from "state/actions/readCheckedActions";
import color from "../../utils/color";

const getTitleCount = (currentPracticeAreasResults, top) => {
    let practiceAreas = currentPracticeAreasResults.map(a => a.title);
    let occurrences = {};
    for (let i = 0, j = practiceAreas.length; i < j; i++) {
        occurrences[practiceAreas[i]] = (occurrences[practiceAreas[i]] || 0) + 1;
    }
    let result = Object.entries(occurrences).map(([title, count]) => ({ title, count }));
    result.sort((a, b) => b.count - a.count);
    return result.slice(0, top);
}
const ReadCheckedTitlesBi = ({ isOverlay = false, closeDialog, currentTitlesResults, chartType }) => {
    const [stats, setStats] = useState([]);
    const dispatch = useDispatch();
    const store = useStore();
    const BiValue = isOverlay ? BI.READ_CHECKED_OVERLAY_TITLES_CHART : BI.READ_CHECKED_TITLES_CHART;
    const chartRef = useTestObjectRef(BiValue);
    useEffect(() => {
        async function getStats() {
            if (currentTitlesResults) {
                let top = 5;
                if (isOverlay) {
                    top = currentTitlesResults.length;
                }
                let result = getTitleCount(currentTitlesResults, top);
                setStats(result);
                if(isOverlay){
                    closeDialog();
                }
            }
        }

        getStats();
    }, [currentTitlesResults]);
    const filterByLawyerIds = legendItem => {
        const result = store.getState().readchecked.readSelectedcurrentTitlesResults;
        if (result) {
            const lawyerIds = result.filter(item => item.title === legendItem.text).map(item => item.lawyerId);
            dispatch(readcheckedfilterAllCompanyResultsByLawyerIds(lawyerIds));
        }
    }

    return (
        <div
            id="ReadCheckedreadTitles"
        >
            {chartType === "Pie" && <Piechart
                label="Titles"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.title)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]} />
            }
            {chartType === "Bar" && <HorizontalBarchart
                label="Titles"
                data={stats.map(item => item.count)}
                labels={stats.map(item => item.title)}
                ref={chartRef}
                legendCallBack={(event, legendItem) => filterByLawyerIds(legendItem)}
                backgroundColors={[...color(stats.length)]} />
            }
        </div>
    );
};
export default ReadCheckedTitlesBi;
